module.exports = __webpack_public_path__ + "static/media/Linkedin.35aa922c.svg";